import React, { useEffect, useState, useMemo } from "react";
import {
  FormControl,
  MenuItem,
  Select,
  Typography,
  InputLabel,
} from "@mui/material";
import { fetchAllContributionPlan } from "../action";
import { useDispatch, useSelector } from "react-redux";
import { decodeId, parseData } from "../utils/helper";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const Content = styled(Typography)`
  margin-bottom: 0.5rem;
`;
const ContributionPlanBundlePicker = ({
  input,
  value,
  reset,
  userHealthFacilityFullPath,
  withLabel = true,
  label = null,
  required = false,
  allRegions,
  region,
  meta,
  error,
  ...props
}) => {
  const [selectedValue, setSelectedValue] = useState();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(fetchAllContributionPlan());
  }, []);
  // }, [allRegions, dispatch]);

  const handleChange = (event) => {
    const selectedRegion = event.target.value;
    setSelectedValue(selectedRegion);
  };

  const contributionData = useSelector(
    (state) => state?.profileReducer?.contributionPlanResponseData
  );

  return (
    <>
      <Content>
        <Typography required={required} color="#666666">
          {label}
          {required ? "*" : ""}
        </Typography>
      </Content>
      <FormControl fullWidth>
        <Select
          value={value}
          onChange={handleChange}
          displayEmpty
          required={required}
          size="small"
          error={meta && meta.touched && meta.error && error}
          {...input}
          {...props}
        >
          <MenuItem disabled value="">
            <em>{t("Select")}</em>
          </MenuItem>
          {contributionData &&
            contributionData.map((region) => (
              <MenuItem key={region.id} value={region.id}>
                {region.name}
              </MenuItem>
            ))}
        </Select>
        {meta && meta.touched && meta.error ? (
          <Typography color="red" fontSize={".8rem"} align={"center"}>
            {error}
          </Typography>
        ) : (
          ""
        )}
      </FormControl>
    </>
  );
};

export default ContributionPlanBundlePicker;
